<div class="page-cont col-12">
  <div class="title-cont">
    <div class="title-cont-left">
      <h4 class="title-h4-blue">{{ title }}</h4>
    </div>

    <div class="exportar-cont">
      <app-exportar
        [data]="insuranceData"
        (exportar)="onExportar($event)"
      ></app-exportar>
    </div>
  </div>
  <hr />
  <div class="campos-cont">
    <app-campos
      [tipo]="'cartera'"
      [camposVisibles]="['corte','selectFilter', 'ramo', 'subramo' ]"
      [camposObligatorios]="['corte']"
      [sLobName]="getSlobName()"
      [lobName]="getLobName()"
      (filterChange)="onFilterChange($event)"
      [opcionesSelectFilter]="opcionesSelectFilter"
    ></app-campos>
  </div>
</div>

<app-insurance-table
  [data]="insuranceData"
  [config]="tableConfig"
  [mensajeNoData]="mensajeNoData"
  [error]="errorStatus"
  [itemsPerPage]="pageSize"
  [serverSidePagination]="true"
  [totalRecordsFromServer]="totalRecordsFromServer"
  [totalPagesFromServer]="totalPagesFromServer"
  [totals]="tableTotals"
  (pageChange)="onPageChange($event)"
></app-insurance-table>
